import React, { useState, useEffect } from 'react';
import { get_json, post_json } from './util';
import { Button, Form, Spinner } from 'react-bootstrap';

function TestFeed() {
    const [feedItems, setFeedItems] = useState('[]');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [preview, setPreview] = useState(null);
    const [feedUrl, setFeedUrl] = useState('');
    const apiUrl = process.env.REACT_APP_BACKEND_URL || `http://localhost:${process.env.PORT_HTTP_HOST || '9011'}`;

    useEffect(() => {
        loadFeedConfig();
    }, []);

    const loadFeedConfig = () => {
        get_json('/api/test_feed/config', (response) => {
            if (response.error) {
                setError('Failed to load feed configuration');
                return;
            }
            setFeedItems(JSON.stringify(response, null, 2));
            setError('');
        });
    };

    const handleSave = () => {
        try {
            const items = JSON.parse(feedItems);
            post_json('/api/test_feed/config', items, (response) => {
                if (response.error) {
                    setError(response.error);
                    return;
                }
                setSuccess('Feed configuration saved successfully');
                setError('');
                setTimeout(() => setSuccess(''), 3000);
            });
        } catch (err) {
            setError('Invalid JSON format');
        }
    };

    const handleReset = () => {
        post_json('/api/test_feed/reset', {}, (response) => {
            if (response.error) {
                setError(response.error);
                return;
            }
            setSuccess('Feed reset successfully');
            setError('');
            setTimeout(() => setSuccess(''), 3000);
        });
    };

    const handlePreview = () => {
        if (!feedUrl.trim()) {
            setError('Please enter a feed URL to preview');
            return;
        }

        setLoading(true);
        setError(null);
        setPreview(null);

        get_json(`/test_feed/preview?url=${encodeURIComponent(feedUrl)}`, (response) => {
            setLoading(false);
            if (response.error) {
                setError(response.error);
                return;
            }
            setPreview(response);
        });
    };

    return (
        <div>
            <h2>Test Feed Configuration</h2>
            <p>Configure the test RSS feed items below. Each request to the feed URL will return the next item in sequence.</p>
            <p>Feed URL: <code>{apiUrl}/rss_test/test</code></p>
            <p>Feed URL: <code>{apiUrl}/rss_test/test/unique</code></p>
            
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}
            
            <Form>
                <Form.Group className="mb-4" controlId="feedItems">
                    <Form.Label>Feed Items (JSON)</Form.Label>
                    <Form.Control
                        as="textarea"
                        value={feedItems}
                        onChange={(e) => setFeedItems(e.target.value)}
                        style={{ 
                            height: '400px',
                            fontFamily: 'monospace',
                            fontSize: '14px',
                            whiteSpace: 'pre',
                            overflowWrap: 'normal',
                            overflowX: 'scroll'
                        }}
                    />
                    <Form.Text className="text-muted">
                        Enter feed items as a JSON array. Each item should have at least 'title' and 'link' fields.
                        Optional fields: description, category, comments, guid, pubDate.
                    </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3" controlId="feedUrl">
                    <Form.Label>Preview External Feed</Form.Label>
                    <Form.Control
                        type="text"
                        value={feedUrl}
                        onChange={(e) => setFeedUrl(e.target.value)}
                        placeholder="Enter RSS feed URL to preview"
                    />
                </Form.Group>
                
                <div className="mt-3">
                    <Button variant="primary" onClick={handleSave} className="me-2">
                        Save Configuration
                    </Button>
                    <Button variant="secondary" onClick={handleReset} className="me-2">
                        Reset Feed
                    </Button>
                    <Button 
                        variant="info" 
                        onClick={handlePreview}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                Loading...
                            </>
                        ) : (
                            'Preview Feed'
                        )}
                    </Button>
                </div>
            </Form>

            {preview && (
                <div className="mt-4">
                    <h3>Feed Preview</h3>
                    <pre className="bg-light p-3 rounded">
                        {JSON.stringify(preview, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
}

export default TestFeed; 